import { useTracking } from './use-tracking';
import { useMseProducts } from '../home/use-product';

export const upgradeTrackingAndRedirect = (triggerSource: string) => {
  const { sendTracking } = useTracking();
  const { usedProduct } = useMseProducts();

  const trackingParams = {
    product_line: 'eureka_mse',
    trigger_source: triggerSource,
    agent_name: `mse_${usedProduct.value.toLowerCase()}`,
    page_url: window.location.href,
  };

  sendTracking('ss_eureka_upgrade_page', 'upgrade_trigger', trackingParams);

  const pathParams = new URLSearchParams({
    ...trackingParams,
    'upgrade-from': window.location.href, // for back button
    header_type: 'pricing_proactive_view', // for pricing page copywriting
  });

  const destinationPath = window.location.origin + '/credits-price' + `?${pathParams.toString()}`;

  window.location.href = destinationPath;
};
